import { ActionStatus } from 'core/design/ActionStatus';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { buildActionType } from 'redux/actions/service/buildActionType';
import { USER_INFO_GET, USER_LOGIN_INFO_HANDLE } from 'redux/constants/users';
import { RootState } from 'redux/reducers';
import { PayloadAction } from 'redux/types/actionTypes';
import { UserInfo, UsersLoginInfo } from 'redux/types/internalTypes';

export const setUsersLoginInfo = (
    info: UsersLoginInfo
): ThunkAction<{}, RootState, {}, PayloadAction<UsersLoginInfo>> => {
    return async dispatch => {
        dispatch({
            type: buildActionType(USER_LOGIN_INFO_HANDLE, ActionStatus.DONE),
            payload: info,
        });
    };
};

export const updateUsersLoginInfo =
    (
        info: Partial<UsersLoginInfo>
    ): ThunkAction<{}, RootState, {}, PayloadAction<UsersLoginInfo>> =>
    async (dispatch, getState) => {
        const usersLoginInfo = getState().usersLoginInfo.data;

        const newInfo = { ...usersLoginInfo, ...info };

        dispatch({
            type: buildActionType(USER_LOGIN_INFO_HANDLE, ActionStatus.DONE),
            payload: newInfo,
        });
    };

export const resetUsersLoginInfo =
    (): ThunkAction<{}, RootState, {}, PayloadAction<UsersLoginInfo>> => async dispatch => {
        dispatch({ type: buildActionType(USER_LOGIN_INFO_HANDLE, ActionStatus.RESET) });
    };

export const setUserInfo = (
    info: UserInfo
): ThunkAction<{}, RootState, {}, PayloadAction<UserInfo>> => {
    return async dispatch => {
        dispatch({
            type: buildActionType(USER_INFO_GET, ActionStatus.DONE),
            payload: info,
        });
    };
};

export const updateUserInfo =
    (info: Partial<UserInfo>): ThunkAction<{}, RootState, {}, PayloadAction<UserInfo>> =>
    async (dispatch, getState) => {
        const userInfo = getState().userInfo.data;

        const newInfo = { ...userInfo, ...info };

        dispatch({
            type: buildActionType(USER_INFO_GET, ActionStatus.DONE),
            payload: newInfo,
        });
    };
